import produce from 'immer'
import {
  useCallback,
  useState
} from 'react'


export const useDraftState = (initialValue)  => {
  const [val, updateValue] = useState(initialValue)
  return [
    val,
    useCallback(updater => {
      updateValue(produce(updater))
    }, [])
  ]
}
